import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, OnChanges } from '@angular/core';
import { PageLoaderService } from '@hub/services/PageLoader';
import { ConfirmationService } from 'primeng/api';
import { NotificationService } from '@hub/services/NotificationService';
import { PaymentGeneratorModel } from '@hub/models/paymentGenerator.model';

@Component({
  selector: 'payment-generator',
  templateUrl: './payment-generator.component.html'
})
export class PaymentGeneratorComponent
  implements OnInit, OnDestroy {

  constructor(
    public notificationService: NotificationService,
    public pageLoaderService: PageLoaderService,
    public confirmationService: ConfirmationService,
  ) {}

  @Input() paymentData: PaymentGeneratorModel;
  @Output() onClose: EventEmitter<any> = new EventEmitter
  @Output() onSave: EventEmitter<any> = new EventEmitter

  display_paymentgenerate: boolean = false;
  display_paymentschedule: boolean = false;

  public OnSave(event) {
    this.paymentData.PaymentsData = event;
    this.onSave.emit(this.paymentData);
  }

  OnClose() {
    setTimeout(() => {
      this.onClose.emit();
    }, 100);
  }

  OnNext(event) {
    this.paymentData = event;
    this.display_paymentschedule = false;
    this.display_paymentgenerate = true;
  }

  OnBack() {
    this.display_paymentschedule = true;
    this.display_paymentgenerate = false;
  }

  ngOnInit() {
    this.display_paymentschedule = true;
  }

  ngOnDestroy() {
  }
}
